import React, {useEffect, useState, useRef} from 'react';
import {GoogleMap, InfoWindow, Marker, useLoadScript} from "@react-google-maps/api"
import {Location} from "./Location";

// https://medium.com/scalereal/integration-of-google-maps-with-react-part-1-86c075ab452a
// https://medium.com/scalereal/integration-of-google-maps-with-react-part-2-947f04945910

export const Map = ({locations = [], selected, onSelect, designatedId, onDesignate}) => {
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: 'AIzaSyAeh2NTiazOSW_kgjBk-dDdbvqH745DRks' // process.env.REACT_APP_GOOGLE_API_KEY,
    })

    const [map, setMap] = useState()

    useEffect(() => {
        if (!map) {
            return
        }
        const bounds = new window.google.maps.LatLngBounds()
        locations?.forEach(({ latitude, longitude }) => bounds.extend({ lat: latitude, lng: longitude }))
        map.fitBounds(bounds)
    }, [locations, map])

    const onLoad = (map) => {
        setMap(map)
    }

    const handleMarkerClick = (loc) => {
        if (loc) {
            map?.panTo({ lat: loc.latitude, lng: loc.longitude })
        }
        if (onSelect) {
            onSelect(loc?.location.id)
        }
    }

    return <div className="ds-map-container">
        {!isLoaded ? (
            <h1>Loading...</h1>
        ) : (
            <GoogleMap
                mapContainerClassName="ds-map"
                onLoad={onLoad}
                onClick={() => handleMarkerClick(null)}
            >
                {locations.map((l, ind) => {
                    return <Marker
                        key={ind}
                        icon={"https://cdn.shopify.com/s/files/1/1504/4854/files/alastin_map_marker.png?v=1690825346"}
                        position={{ lat: l.latitude, lng: l.longitude }}
                        onClick={() => {
                            handleMarkerClick(l)
                        }}
                    >
                        {l.location.id === selected && (
                            <InfoWindow
                                onCloseClick={() => {
                                    handleMarkerClick(null)
                                }}
                            >
                                <Location location={l.location} onDesignate={onDesignate} designated={l.location.id == designatedId} />
                            </InfoWindow>
                        )}
                    </Marker>
                })}
            </GoogleMap>
        )}
    </div>
}

export const MapList = ({locations, designatedId, onDesignate}) => {
    const [highlightedId, setHighlightedId] = useState()

    return <div className="ds-flex-box">
        <div className="ds-location-list">
            <ul className="ds-location-list-group">
                {locations.map((result, i) =>
                    <ResultRow
                        key={result.location.id}
                        result={result}
                        designated={result.location.id === designatedId}
                        highlighted={result.location.id === highlightedId}
                        onDesignate={onDesignate}
                        onClick={setHighlightedId}
                    />
                )}
            </ul>
        </div>
        <Map
            locations={locations}
            selected={highlightedId}
            onSelect={setHighlightedId}
            designated={designatedId}
            onDesignate={onDesignate}
        />
    </div>
}

let roundDistance = (distance) => {
    return Math.round(distance * 100) / 100;
}

const ResultRow = ({result, designated, highlighted, onDesignate, onClick}) => {
    const myRef = useRef(null)

    useEffect(() => {
        if (highlighted) {
            myRef.current.scrollIntoView()
        }
    }, [highlighted])

    let classes = ['ds-location-list-item']
    if (highlighted) {
        classes.push('selected')
    }
    if (designated) {
        classes.push('designated')
    }
    return <li ref={myRef} className={classes.join(' ')} onClick={() => onClick(result.location.id)}>
        {result.distance !== null && <p className="ds-location-distance">{roundDistance(result.distance)} miles</p>}
        <Location location={result.location} designated={designated} onDesignate={onDesignate} />
    </li>
}
